import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';

@Injectable({
  providedIn: 'root'
})
export class MemberGn1Service {

  constructor (
    public db: AngularFirestore
  ) { }

  readCSVFile (fileInput: any) {
    //read file from input
    let errors: any[] = []
    let fileReaded: any
    let gn1Members: any[] = []

    errors = [];

    fileReaded = fileInput.target.files[ 0 ];

    let reader: FileReader = new FileReader();
    reader.readAsText(fileReaded);

    reader.onload = (e) => {
      let csv: any = reader.result;
      let allTextLines = csv.split(/\r\n|\n/);
      let headers = allTextLines[ 0 ].split(';');
      let lines = [];

      for (var i = 2; i < allTextLines.length; i++) {
        //console.log(allTextLines[i])
        let data = allTextLines[ i ].split(';');

        if (data[ 0 ] != "") {

          let tarr = []
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[ j ]);
          }

          lines.push(tarr);
        }
      }

      for (let i = 0; i < lines.length; i++) {
        let entity: any = {}

        entity.excel_id = lines[ i ][ 0 ]
        entity.name = lines[ i ][ 1 ]
        entity.category = lines[ i ][ 2 ]
        entity.situation = lines[ i ][ 3 ]
        entity.address = lines[ i ][ 4 ]
        entity.number = lines[ i ][ 5 ]
        entity.complement = lines[ i ][ 6 ]
        entity.district = lines[ i ][ 7 ]
        entity.postalCode = lines[ i ][ 8 ]
        entity.city = lines[ i ][ 9 ]
        entity.state = lines[ i ][ 10 ]
        entity.email = lines[ i ][ 11 ]
        entity.email2 = lines[ i ][ 12 ]
        entity.cellPhone = lines[ i ][ 13 ]
        entity.faxPhone = lines[ i ][ 14 ]
        entity.clinicPhone = lines[ i ][ 15 ]
        entity.hospitalPhone = lines[ i ][ 16 ]
        entity.auxPhone1 = lines[ i ][ 17 ]
        entity.auxPhone2 = lines[ i ][ 18 ]
        entity.rg = lines[ i ][ 19 ]
        entity.cpf = lines[ i ][ 20 ]
        entity.crm = lines[ i ][ 21 ]
        entity.birthDate = lines[ i ][ 22 ]
        entity.filiationDate = lines[ i ][ 23 ]
        entity.titleDate = lines[ i ][ 24 ]
        entity.institute = lines[ i ][ 25 ]
        entity.regional = lines[ i ][ 26 ]
        entity.gender = lines[ i ][ 27 ]
        entity.concilState = lines[ i ][ 28 ]
        entity.specialization = lines[ i ][ 29 ]
        entity.exclude = false

        //console.log(entity)
        // gn1Members.push(entity)
        //
        this.insert(entity)
          .then((e) => {
            console.log(i + " - " + e.id)
          })
          .catch((err) => {
            console.log(err.message)
          })

      }

      // console.log(JSON.stringify(gn1Members))

    }
  }

  selectGN1 () {
    return this.db.collection<any>('sbccv_gn1', ref =>
      ref.orderBy('name', 'asc')).get();
  }

  insertGN1 (entity: any) {
    return this.db.collection('sbccv_gn1').add(Object.assign({}, entity));
  }

  selectWork () {
    return this.db.collection<any>('sbccv_gn1_work', ref => ref
      .where("exclude", '==', false)
      .orderBy('name', 'asc')).snapshotChanges()
  }

  selectWorkExcluded () {
    return this.db.collection<any>('sbccv_gn1_work', ref => ref
      .where("exclude", '==', true)
      .orderBy('name', 'asc')).snapshotChanges()
  }

  insert (entity: any) {
    return this.db.collection('sbccv_gn1_work').add(Object.assign({}, entity));
  }

  update (entity: any) {
    return this.db.collection('sbccv_gn1_work').doc(entity.id).set(Object.assign({}, entity), {merge: true});
  }

  async updateFormation (id: string, entity: any) {
    return this.db.collection('sbccv_gn1_work').doc(id).set(Object.assign({}, entity), {merge: true});
  }

  async updateMemberFormation (id: string, entity: any) {
    return this.db.collection('sbccv_members').doc(id).set(Object.assign({}, entity), {merge: true});
  }

  createEntity (data: any) {

    return {
      'id': data.id,
      'name': data.name,
      'category': data.category,
      'email': data.email,
      'cellPhone': data.cellPhone,
      'cpf': data.cpf,
      'crm': data.crm,
      'birthDate': data.birthDate,
      'filiationDate': data.filiationDate,
      'exclude': data.exclude
    }

  }

  loadSBCCVMembers () {
    return this.db.collection<any>('sbccv_members', ref =>
      ref.orderBy('name', 'asc')).snapshotChanges();
  }


  updateExcluded (entity: any) {
    return this.db.collection('sbccv_gn1_work').doc(entity.id).set(Object.assign({}, entity), {merge: true});
  }

  readCSVFormation (fileInput: any, sbccvMembers: any[], gn1Members: any[]) {

    console.log(sbccvMembers.length)
    console.log(gn1Members.length)

    let fileReaded: any
    fileReaded = fileInput.target.files[ 0 ];

    let reader: FileReader = new FileReader();
    reader.readAsText(fileReaded);

    reader.onload = (e) => {
      let csv: any = reader.result;
      let allTextLines = csv.split(/\r\n|\n/);
      let headers = allTextLines[ 0 ].split(';');
      let lines = [];

      for (var i = 2; i < allTextLines.length; i++) {//allTextLines.length

        let data = allTextLines[ i ].split(';');

        if (data[ 0 ] != "") {

          let tarr = []
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[ j ]);
          }

          lines.push(tarr);
        }
      }

      const dataArray: any = []
      const foundArray: any = []
      const notFoundArray: any = []

      for (let i = 0; i < lines.length; i++) {
        let entity: any = {}

        entity.name = lines[ i ][ 0 ]
        entity.category = lines[ i ][ 1 ]
        entity.cpf = this.cleanCPF(lines[ i ][ 2 ])
        entity.text = lines[ i ][ 3 ]
        entity.dateBegin = this.makeDate(lines[ i ][ 4 ])
        entity.dateEnd = this.makeDate(lines[ i ][ 5 ])

        //console.log(entity)
        dataArray.push(entity)

      }

      //console.log(JSON.stringify(dataArray))
      dataArray.forEach((data) => {

        if (data.text) {

          const exist = sbccvMembers.find((e) => {
            return this.cleanCPF(data.cpf) === e.cpf
          })

          if (exist) {

            const entity = {
              'resident_institute': data.text,
              'resident_begin': data.dateBegin,
              'resident_end': data.dateEnd
            }
            foundArray.push({ 'id': exist.id, 'name': exist.name, data: entity})
          } else {
            notFoundArray.push(data)
          }
        }
      })

      console.log("OK: " + JSON.stringify(foundArray))
      console.log("----------------------------------")
      console.log("ERROR: " + JSON.stringify(notFoundArray))

    }
  }

  cleanCPF (cpf) {
    if (cpf === ' Vazio')
      return ""
    else
      return cpf.replace(".", "").replace(".", "").replace("-", "")
  }

  makeDate (dt) {
    const textDate = dt;
    // Divide a string em dia, mês e ano
    const [ day, month, year ] = textDate.split('/').map(Number);
    // Cria um objeto Date (note que o mês é zero-indexado, então subtraímos 1)
    const date = new Date(year, month - 1, day, 0, 0, 0);
    return date
  }


}
